import { GetStaticPaths } from 'next'
import { IBlogPillar, PILLAR_BLOG_TOPICS, TOPIC_MAP } from 'src/utils/hygraph'
import Page, { getStaticProps } from '../../blog/index'

export default Page

export const getStaticPaths = (async ({ locales = [] }) => {
  const paths: { params: { pillar: IBlogPillar }; locale: string }[] = locales
    .map((locale) =>
      PILLAR_BLOG_TOPICS.map((topic) => ({
        params: { pillar: TOPIC_MAP[topic].pillar as IBlogPillar },
        locale
      }))
    )
    .flat()
  return { paths, fallback: false }
}) satisfies GetStaticPaths

export { getStaticProps }
